import { createContext, useContext, useState } from 'react';

const QuizContext = createContext();

export const QuizProvider = ({ children }) => {
	const [showQuiz, setShowQuiz] = useState(false);
	const [quizCompleted, setQuizCompleted] = useState(false);

	// Добавляем отладочную информацию
	const setShowQuizWithLog = (value) => {
		console.log('QuizContext: setShowQuiz вызывается с значением:', value);
		setShowQuiz(value);
	};

	return (
		<QuizContext.Provider value={{
			showQuiz,
			setShowQuiz: setShowQuizWithLog,
			quizCompleted,
			setQuizCompleted
		}}>
			{children}
		</QuizContext.Provider>
	);
};

export const useQuiz = () => {
	const context = useContext(QuizContext);
	if (!context) {
		throw new Error('useQuiz must be used within a QuizProvider');
	}
	return context;
};
